var _circle, _path, _mask, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyOutputTabIcon = function SvgEmptyOutputTabIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none",
    viewBox: "0 0 52 52"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#E5E5FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#3D4355",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M41.296 18.41a4 4 0 0 1 1.204 2.86q0 0 0 0V47.5a4 4 0 0 1-4 4h-27a4 4 0 0 1-4-4v-36a4 4 0 0 1 4-4h17.01q0 0 0 0a4 4 0 0 1 2.796 1.14q0 0 0 0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "EmptyOutputTabIcon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 7v9a4.5 4.5 0 0 0 4.5 4.5h9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "M34 20.5v1zM28.5 7v9h2V7zm0 9a5.5 5.5 0 0 0 1.61 3.89l1.415-1.415A3.5 3.5 0 0 1 30.5 16zm1.61 3.89A5.5 5.5 0 0 0 34 21.5v-2a3.5 3.5 0 0 1-2.475-1.025zM34 21.5h9v-2h-9z",
    mask: "url(#EmptyOutputTabIcon_svg__a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 1,
    x: 14,
    y: 43,
    fill: "#3D4355",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 1,
    x: 14,
    y: 36,
    fill: "#3D4355",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 1,
    x: 14,
    y: 29,
    fill: "#3D4355",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 14,
    y: 22,
    fill: "#3D4355",
    rx: 0.5
  })));
};
export default SvgEmptyOutputTabIcon;